module.exports = __webpack_public_path__ + "static/media/SWSCRC6-26.a965d53f.mp3";